import React from 'react';
import EditorOutdent from '@wix/da-ds/pkg/Icons/24x24/EditorOutdent';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
const Outdent = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'indent')) {
        return null;
    }
    if (editor.isActive('listItem')) {
        return /*#__PURE__*/ React.createElement(EditorIconButton, {
            featureId: "format:outdent",
            icon: EditorOutdent,
            onClick: ()=>editor.chain().focus().liftListItem('listItem').run(),
            disabled: !editor.can().liftListItem('listItem'),
            tooltipText: t('button.outdent'),
            "aria-label": t('button.outdent')
        });
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "format:outdent",
        icon: EditorOutdent,
        onClick: ()=>editor.chain().focus().outdent('block').run(),
        disabled: !editor.can().chain().focus().outdent('block').run(),
        tooltipText: t('button.outdent'),
        "aria-label": t('button.outdent')
    });
};
Outdent.displayName = 'Outdent';
export default Outdent;

//# sourceMappingURL=Outdent.js.map